import { useEffect, useState, useRef } from "react"
import { useTraduction } from "../../Contexte/TraductionContext";

function SavoirFaire() {

    const { contentAccueil } = useTraduction()

    const [currentIndex, setCurrentIndex] = useState(0);
    const coulissantRefCommerciaux = useRef(null);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndex(prevIndex =>
                prevIndex === totalImagesCommerciaux - 1 ? 0 : prevIndex + 1
            );
        }, 5000);

        return () => clearInterval(intervalId);
    }, []);

    const ImagesCommerciaux = [
        "../../../Assets/visuels/images/home/knows/commerciaux.webp", 
        "../../../Assets/visuels/images/home/knows/commerciaux1.webp"
    ];


    const totalImagesCommerciaux = ImagesCommerciaux.length;

    const [currentIndexAtelier, setCurrentIndexAtelier] = useState(0);
    const coulissantRefAtelier = useRef(null);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndexAtelier(prevIndex =>
                prevIndex === totalImagesAtelier - 1 ? 0 : prevIndex + 1
            );
        }, 5000);

        return () => clearInterval(intervalId);
    }, []);

    const ImagesAtelier = [
        "../../../Assets/visuels/images/home/knows/atelier1.webp", 
        "../../../Assets/visuels/images/home/knows/atelier2.webp"
    ];
    const totalImagesAtelier = ImagesAtelier.length;

    const [currentIndexLigne, setCurrentIndexLigne] = useState(0);
    const coulissantRefLigne = useRef(null);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndexLigne(prevIndex =>
                prevIndex === totalImagesLigne - 1 ? 0 : prevIndex + 1
            );
        }, 5000);

        return () => clearInterval(intervalId);
    }, []);

    const ImagesLigne = [
        "../../../Assets/visuels/images/home/knows/ligne1.webp", 
        "../../../Assets/visuels/images/home/knows/ligne3.webp", 
        "../../../Assets/visuels/images/home/knows/ligne4.webp", 
        "../../../Assets/visuels/images/home/knows/ligne5.webp", 
        "../../../Assets/visuels/images/home/knows/ligne6.webp"
    ];
    const totalImagesLigne = ImagesLigne.length;

    const ImagesOffice = [
        "../../../Assets/visuels/images/home/knows/office.webp", 
        "../../../Assets/visuels/images/home/knows/office1.webp"
    ];

    return <>
    <span id="Ancre1"></span>
        <section id="SavoirFaire" className="container mt-124">
        <h3>{contentAccueil.GrosTitreSavoir}</h3>
        <div className="horizontale mt-64">
            <div className="Carrousel">
                <div className="Coulissant" ref={coulissantRefCommerciaux} style={{ transform: `translateX(${-currentIndex * 50}%)` }}>
                    {ImagesCommerciaux.map((image, index) => (
                        <img loading="lazy" key={index} alt="Ancienne Photographie des ateliers et convoyeurs de Renau Transportadors S.L" src={image} style={{ width: `${coulissantRefCommerciaux.current ? coulissantRefCommerciaux.current.clientWidth / totalImagesCommerciaux : 'auto'}px` }} />
                    ))}
                </div>
            </div>
            <div className="content">
                <div>
                    <p className="number">01</p>
                    <p className="title">{contentAccueil.Savoir1.Titre}</p>
                </div>
                <ul className="mt-16">
                    <li>
                        <p>{contentAccueil.Savoir1.Arg1}</p>
                    </li>
                    <li>
                        <p>{contentAccueil.Savoir1.Arg2}</p>
                    </li>
                    <li>
                        <p>{contentAccueil.Savoir1.Arg3}</p>
                    </li>
                    <li>
                        <p>{contentAccueil.Savoir1.Arg4}</p>
                    </li>
                </ul>
            </div>
        </div>

        <div className="horizontale">
            <div className="content">
                <div>
                    <p className="number">02</p>
                    <p className="title">{contentAccueil.Savoir2.Titre}</p>
                </div>
                <ul className="mt-16">
                    <li>
                        <p>{contentAccueil.Savoir2.Arg1}</p>
                    </li>
                    <li>
                        <p>{contentAccueil.Savoir2.Arg2}</p>
                    </li>
                    <li>
                        <p>{contentAccueil.Savoir2.Arg3}</p>
                    </li>
                    <li>
                        <p>{contentAccueil.Savoir2.Arg4}</p>
                    </li>
                </ul>
            </div>
            <div className="Carrousel">
                <div className="Coulissant" ref={coulissantRefAtelier} style={{ transform: `translateX(${-currentIndexAtelier * 50}%)` }}>
                    {ImagesOffice.map((image, index) => (
                        <img loading="lazy" key={index} alt="Ancienne Photographie des ateliers et convoyeurs de Renau Transportadors S.L" src={image} style={{ width: `${coulissantRefAtelier.current ? coulissantRefAtelier.current.clientWidth / totalImagesAtelier : 'auto'}px` }} />
                    ))}
                </div>
            </div>
        </div>

        <div className="horizontale">
            <div className="Carrousel">
                <div className="Coulissant" ref={coulissantRefAtelier} style={{ transform: `translateX(${-currentIndexAtelier * 50}%)` }}>
                    {ImagesAtelier.map((image, index) => (
                        <img loading="lazy" key={index} alt="Ancienne Photographie des ateliers et convoyeurs de Renau Transportadors S.L" src={image} style={{ width: `${coulissantRefAtelier.current ? coulissantRefAtelier.current.clientWidth / totalImagesAtelier : 'auto'}px` }} />
                    ))}
                </div>
            </div>
            <div className="content">
                <div>
                    <p className="number">03</p>
                    <p className="title">{contentAccueil.Savoir3.Titre}</p>
                </div>
                <ul className="mt-16">
                    <li>
                        <p>{contentAccueil.Savoir3.Arg1}</p>
                    </li>
                    <li>
                        <p>{contentAccueil.Savoir3.Arg2}</p>
                    </li>
                    <li>
                        <p>{contentAccueil.Savoir3.Arg3}</p>
                    </li>
                    <li>
                        <p>{contentAccueil.Savoir3.Arg4}</p>
                    </li>
                    <li>
                        <p>{contentAccueil.Savoir3.Arg5}</p>
                    </li>
                    <li>
                        <p>{contentAccueil.Savoir3.Arg6}</p>
                    </li>
                </ul>
            </div>
        </div>

        <div className="horizontale">
            <div className="content">
                <div>
                    <p className="number">04</p>
                    <p className="title">{contentAccueil.Savoir4.Titre}</p>
                </div>
                <ul className="mt-16">
                    <li>
                        <p>{contentAccueil.Savoir4.Arg1}</p>
                    </li>
                    <li>
                        <p>{contentAccueil.Savoir4.Arg2}</p>
                    </li>
                    <li>
                        <p>{contentAccueil.Savoir4.Arg3}</p>
                    </li>
                </ul>
            </div>
            <div className="Carrousel">
                <div className="Coulissant" ref={coulissantRefLigne} style={{ transform: `translateX(${-currentIndexLigne * 20}%)`, width: "500%" }}>
                    {ImagesLigne.map((image, index) => (
                        <img loading="lazy" key={index} alt="Ancienne Photographie des ateliers et convoyeurs de Renau Transportadors S.L" src={image} style={{ width: `${coulissantRefLigne.current ? coulissantRefLigne.current.clientWidth / totalImagesLigne : 'auto'}px` }} />
                    ))}
                </div>
            </div>
        </div>
    </section>
    </>
}

export default SavoirFaire